// extracted by mini-css-extract-plugin
module.exports = {"content":"PatchTestWarningPopup-module--content--c0f41e","header":"PatchTestWarningPopup-module--header--60b4ad"};